import { Col, Row } from 'antd';
import { RevxDate, SHIPPING_DATE_FORMAT } from 'components/RevxDate';
import { RFMOffer } from 'domains/workspaceDomain';
import { useTranslation } from 'react-i18next';

/**
 * Ship date and method saved on an offer, shown in the offer detail row.
 */
const OfferShippingSummary = ({ offer }: { offer: RFMOffer }) => {
  const { t } = useTranslation();
  const adjustments = offer.shippingAdjustments || [];

  if (!adjustments.length) {
    return null;
  }

  return (
    <>
      {adjustments.map((adjustment) => (
        <Row key={adjustment.jobShippingItemSpecId}>
          <Col span={8} offset={2}>
            {t('workspace.rfm.offerShipping.shippingMethod')}:{' '}
            {adjustment.carrierService || '-'}
          </Col>
          <Col span={6}>
            {t('workspace.rfm.offerShipping.shipDate')}:{' '}
            <RevxDate
              dateStr={adjustment.estimatedShipTime}
              formatStr={SHIPPING_DATE_FORMAT}
            />
          </Col>
          <Col span={6}>
            {t('workspace.rfm.offerShipping.arrivalDate')}:{' '}
            <RevxDate
              dateStr={adjustment.estimatedDeliveryTime}
              formatStr={SHIPPING_DATE_FORMAT}
            />
          </Col>
        </Row>
      ))}
    </>
  );
};

export default OfferShippingSummary;
